/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "pt-AO": {
        "nu": ["latn"],
        "year": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-short": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-narrow": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "+{0} ano",
            "other": "+{0} anos"
          },
          "past": {
            "one": "-{0} ano",
            "other": "-{0} anos"
          },
          "-1": "ano passado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "há {0} trimestre",
            "other": "há {0} trimestres"
          },
          "-1": "trimestre passado"
        },
        "quarter-short": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "há {0} trim.",
            "other": "há {0} trim."
          },
          "-1": "trim. passado"
        },
        "quarter-narrow": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "+{0} trim.",
            "other": "+{0} trim."
          },
          "past": {
            "one": "-{0} trim.",
            "other": "-{0} trim."
          },
          "-1": "trim. passado"
        },
        "month": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-short": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-narrow": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "+{0} mês",
            "other": "+{0} meses"
          },
          "past": {
            "one": "-{0} mês",
            "other": "-{0} meses"
          },
          "-1": "mês passado"
        },
        "week": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "há {0} semana",
            "other": "há {0} semanas"
          },
          "-1": "semana passada"
        },
        "week-short": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "há {0} sem.",
            "other": "há {0} sem."
          },
          "-1": "semana passada"
        },
        "week-narrow": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "+{0} sem.",
            "other": "+{0} sem."
          },
          "past": {
            "one": "-{0} sem.",
            "other": "-{0} sem."
          },
          "-1": "semana passada"
        },
        "day": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-short": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-narrow": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "+{0} dia",
            "other": "+{0} dias"
          },
          "past": {
            "one": "há {0} dias",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "há {0} hora",
            "other": "há {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "há {0} h",
            "other": "há {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "+{0} h",
            "other": "+{0} h"
          },
          "past": {
            "one": "-{0} h",
            "other": "-{0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "há {0} minuto",
            "other": "há {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "há {0} min",
            "other": "há {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "+{0} min",
            "other": "+{0} min"
          },
          "past": {
            "one": "-{0} min",
            "other": "-{0} min"
          }
        },
        "second": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "há {0} segundo",
            "other": "há {0} segundos"
          }
        },
        "second-short": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "há {0} s",
            "other": "há {0} s"
          }
        },
        "second-narrow": {
          "0": "agora",
          "future": {
            "one": "+{0} s",
            "other": "+{0} s"
          },
          "past": {
            "one": "-{0} s",
            "other": "-{0} s"
          }
        }
      },
      "pt-CH": {
        "nu": ["latn"],
        "year": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-short": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-narrow": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "+{0} ano",
            "other": "+{0} anos"
          },
          "past": {
            "one": "-{0} ano",
            "other": "-{0} anos"
          },
          "-1": "ano passado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "há {0} trimestre",
            "other": "há {0} trimestres"
          },
          "-1": "trimestre passado"
        },
        "quarter-short": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "há {0} trim.",
            "other": "há {0} trim."
          },
          "-1": "trim. passado"
        },
        "quarter-narrow": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "+{0} trim.",
            "other": "+{0} trim."
          },
          "past": {
            "one": "-{0} trim.",
            "other": "-{0} trim."
          },
          "-1": "trim. passado"
        },
        "month": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-short": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-narrow": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "+{0} mês",
            "other": "+{0} meses"
          },
          "past": {
            "one": "-{0} mês",
            "other": "-{0} meses"
          },
          "-1": "mês passado"
        },
        "week": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "há {0} semana",
            "other": "há {0} semanas"
          },
          "-1": "semana passada"
        },
        "week-short": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "há {0} sem.",
            "other": "há {0} sem."
          },
          "-1": "semana passada"
        },
        "week-narrow": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "+{0} sem.",
            "other": "+{0} sem."
          },
          "past": {
            "one": "-{0} sem.",
            "other": "-{0} sem."
          },
          "-1": "semana passada"
        },
        "day": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-short": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-narrow": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "+{0} dia",
            "other": "+{0} dias"
          },
          "past": {
            "one": "há {0} dias",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "há {0} hora",
            "other": "há {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "há {0} h",
            "other": "há {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "+{0} h",
            "other": "+{0} h"
          },
          "past": {
            "one": "-{0} h",
            "other": "-{0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "há {0} minuto",
            "other": "há {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "há {0} min",
            "other": "há {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "+{0} min",
            "other": "+{0} min"
          },
          "past": {
            "one": "-{0} min",
            "other": "-{0} min"
          }
        },
        "second": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "há {0} segundo",
            "other": "há {0} segundos"
          }
        },
        "second-short": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "há {0} s",
            "other": "há {0} s"
          }
        },
        "second-narrow": {
          "0": "agora",
          "future": {
            "one": "+{0} s",
            "other": "+{0} s"
          },
          "past": {
            "one": "-{0} s",
            "other": "-{0} s"
          }
        }
      },
      "pt-CV": {
        "nu": ["latn"],
        "year": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-short": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-narrow": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "+{0} ano",
            "other": "+{0} anos"
          },
          "past": {
            "one": "-{0} ano",
            "other": "-{0} anos"
          },
          "-1": "ano passado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "há {0} trimestre",
            "other": "há {0} trimestres"
          },
          "-1": "trimestre passado"
        },
        "quarter-short": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "há {0} trim.",
            "other": "há {0} trim."
          },
          "-1": "trim. passado"
        },
        "quarter-narrow": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "+{0} trim.",
            "other": "+{0} trim."
          },
          "past": {
            "one": "-{0} trim.",
            "other": "-{0} trim."
          },
          "-1": "trim. passado"
        },
        "month": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-short": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-narrow": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "+{0} mês",
            "other": "+{0} meses"
          },
          "past": {
            "one": "-{0} mês",
            "other": "-{0} meses"
          },
          "-1": "mês passado"
        },
        "week": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "há {0} semana",
            "other": "há {0} semanas"
          },
          "-1": "semana passada"
        },
        "week-short": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "há {0} sem.",
            "other": "há {0} sem."
          },
          "-1": "semana passada"
        },
        "week-narrow": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "+{0} sem.",
            "other": "+{0} sem."
          },
          "past": {
            "one": "-{0} sem.",
            "other": "-{0} sem."
          },
          "-1": "semana passada"
        },
        "day": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-short": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-narrow": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "+{0} dia",
            "other": "+{0} dias"
          },
          "past": {
            "one": "há {0} dias",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "há {0} hora",
            "other": "há {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "há {0} h",
            "other": "há {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "+{0} h",
            "other": "+{0} h"
          },
          "past": {
            "one": "-{0} h",
            "other": "-{0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "há {0} minuto",
            "other": "há {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "há {0} min",
            "other": "há {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "+{0} min",
            "other": "+{0} min"
          },
          "past": {
            "one": "-{0} min",
            "other": "-{0} min"
          }
        },
        "second": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "há {0} segundo",
            "other": "há {0} segundos"
          }
        },
        "second-short": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "há {0} s",
            "other": "há {0} s"
          }
        },
        "second-narrow": {
          "0": "agora",
          "future": {
            "one": "+{0} s",
            "other": "+{0} s"
          },
          "past": {
            "one": "-{0} s",
            "other": "-{0} s"
          }
        }
      },
      "pt-GQ": {
        "nu": ["latn"],
        "year": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-short": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-narrow": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "+{0} ano",
            "other": "+{0} anos"
          },
          "past": {
            "one": "-{0} ano",
            "other": "-{0} anos"
          },
          "-1": "ano passado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "há {0} trimestre",
            "other": "há {0} trimestres"
          },
          "-1": "trimestre passado"
        },
        "quarter-short": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "há {0} trim.",
            "other": "há {0} trim."
          },
          "-1": "trim. passado"
        },
        "quarter-narrow": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "+{0} trim.",
            "other": "+{0} trim."
          },
          "past": {
            "one": "-{0} trim.",
            "other": "-{0} trim."
          },
          "-1": "trim. passado"
        },
        "month": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-short": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-narrow": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "+{0} mês",
            "other": "+{0} meses"
          },
          "past": {
            "one": "-{0} mês",
            "other": "-{0} meses"
          },
          "-1": "mês passado"
        },
        "week": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "há {0} semana",
            "other": "há {0} semanas"
          },
          "-1": "semana passada"
        },
        "week-short": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "há {0} sem.",
            "other": "há {0} sem."
          },
          "-1": "semana passada"
        },
        "week-narrow": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "+{0} sem.",
            "other": "+{0} sem."
          },
          "past": {
            "one": "-{0} sem.",
            "other": "-{0} sem."
          },
          "-1": "semana passada"
        },
        "day": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-short": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-narrow": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "+{0} dia",
            "other": "+{0} dias"
          },
          "past": {
            "one": "há {0} dias",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "há {0} hora",
            "other": "há {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "há {0} h",
            "other": "há {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "+{0} h",
            "other": "+{0} h"
          },
          "past": {
            "one": "-{0} h",
            "other": "-{0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "há {0} minuto",
            "other": "há {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "há {0} min",
            "other": "há {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "+{0} min",
            "other": "+{0} min"
          },
          "past": {
            "one": "-{0} min",
            "other": "-{0} min"
          }
        },
        "second": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "há {0} segundo",
            "other": "há {0} segundos"
          }
        },
        "second-short": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "há {0} s",
            "other": "há {0} s"
          }
        },
        "second-narrow": {
          "0": "agora",
          "future": {
            "one": "+{0} s",
            "other": "+{0} s"
          },
          "past": {
            "one": "-{0} s",
            "other": "-{0} s"
          }
        }
      },
      "pt-GW": {
        "nu": ["latn"],
        "year": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-short": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-narrow": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "+{0} ano",
            "other": "+{0} anos"
          },
          "past": {
            "one": "-{0} ano",
            "other": "-{0} anos"
          },
          "-1": "ano passado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "há {0} trimestre",
            "other": "há {0} trimestres"
          },
          "-1": "trimestre passado"
        },
        "quarter-short": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "há {0} trim.",
            "other": "há {0} trim."
          },
          "-1": "trim. passado"
        },
        "quarter-narrow": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "+{0} trim.",
            "other": "+{0} trim."
          },
          "past": {
            "one": "-{0} trim.",
            "other": "-{0} trim."
          },
          "-1": "trim. passado"
        },
        "month": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-short": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-narrow": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "+{0} mês",
            "other": "+{0} meses"
          },
          "past": {
            "one": "-{0} mês",
            "other": "-{0} meses"
          },
          "-1": "mês passado"
        },
        "week": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "há {0} semana",
            "other": "há {0} semanas"
          },
          "-1": "semana passada"
        },
        "week-short": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "há {0} sem.",
            "other": "há {0} sem."
          },
          "-1": "semana passada"
        },
        "week-narrow": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "+{0} sem.",
            "other": "+{0} sem."
          },
          "past": {
            "one": "-{0} sem.",
            "other": "-{0} sem."
          },
          "-1": "semana passada"
        },
        "day": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-short": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-narrow": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "+{0} dia",
            "other": "+{0} dias"
          },
          "past": {
            "one": "há {0} dias",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "há {0} hora",
            "other": "há {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "há {0} h",
            "other": "há {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "+{0} h",
            "other": "+{0} h"
          },
          "past": {
            "one": "-{0} h",
            "other": "-{0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "há {0} minuto",
            "other": "há {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "há {0} min",
            "other": "há {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "+{0} min",
            "other": "+{0} min"
          },
          "past": {
            "one": "-{0} min",
            "other": "-{0} min"
          }
        },
        "second": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "há {0} segundo",
            "other": "há {0} segundos"
          }
        },
        "second-short": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "há {0} s",
            "other": "há {0} s"
          }
        },
        "second-narrow": {
          "0": "agora",
          "future": {
            "one": "+{0} s",
            "other": "+{0} s"
          },
          "past": {
            "one": "-{0} s",
            "other": "-{0} s"
          }
        }
      },
      "pt-LU": {
        "nu": ["latn"],
        "year": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-short": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-narrow": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "+{0} ano",
            "other": "+{0} anos"
          },
          "past": {
            "one": "-{0} ano",
            "other": "-{0} anos"
          },
          "-1": "ano passado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "há {0} trimestre",
            "other": "há {0} trimestres"
          },
          "-1": "trimestre passado"
        },
        "quarter-short": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "há {0} trim.",
            "other": "há {0} trim."
          },
          "-1": "trim. passado"
        },
        "quarter-narrow": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "+{0} trim.",
            "other": "+{0} trim."
          },
          "past": {
            "one": "-{0} trim.",
            "other": "-{0} trim."
          },
          "-1": "trim. passado"
        },
        "month": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-short": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-narrow": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "+{0} mês",
            "other": "+{0} meses"
          },
          "past": {
            "one": "-{0} mês",
            "other": "-{0} meses"
          },
          "-1": "mês passado"
        },
        "week": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "há {0} semana",
            "other": "há {0} semanas"
          },
          "-1": "semana passada"
        },
        "week-short": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "há {0} sem.",
            "other": "há {0} sem."
          },
          "-1": "semana passada"
        },
        "week-narrow": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "+{0} sem.",
            "other": "+{0} sem."
          },
          "past": {
            "one": "-{0} sem.",
            "other": "-{0} sem."
          },
          "-1": "semana passada"
        },
        "day": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-short": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-narrow": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "+{0} dia",
            "other": "+{0} dias"
          },
          "past": {
            "one": "há {0} dias",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "há {0} hora",
            "other": "há {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "há {0} h",
            "other": "há {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "+{0} h",
            "other": "+{0} h"
          },
          "past": {
            "one": "-{0} h",
            "other": "-{0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "há {0} minuto",
            "other": "há {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "há {0} min",
            "other": "há {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "+{0} min",
            "other": "+{0} min"
          },
          "past": {
            "one": "-{0} min",
            "other": "-{0} min"
          }
        },
        "second": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "há {0} segundo",
            "other": "há {0} segundos"
          }
        },
        "second-short": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "há {0} s",
            "other": "há {0} s"
          }
        },
        "second-narrow": {
          "0": "agora",
          "future": {
            "one": "+{0} s",
            "other": "+{0} s"
          },
          "past": {
            "one": "-{0} s",
            "other": "-{0} s"
          }
        }
      },
      "pt-MO": {
        "nu": ["latn"],
        "year": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-short": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-narrow": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "+{0} ano",
            "other": "+{0} anos"
          },
          "past": {
            "one": "-{0} ano",
            "other": "-{0} anos"
          },
          "-1": "ano passado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "há {0} trimestre",
            "other": "há {0} trimestres"
          },
          "-1": "trimestre passado"
        },
        "quarter-short": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "há {0} trim.",
            "other": "há {0} trim."
          },
          "-1": "trim. passado"
        },
        "quarter-narrow": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "+{0} trim.",
            "other": "+{0} trim."
          },
          "past": {
            "one": "-{0} trim.",
            "other": "-{0} trim."
          },
          "-1": "trim. passado"
        },
        "month": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-short": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-narrow": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "+{0} mês",
            "other": "+{0} meses"
          },
          "past": {
            "one": "-{0} mês",
            "other": "-{0} meses"
          },
          "-1": "mês passado"
        },
        "week": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "há {0} semana",
            "other": "há {0} semanas"
          },
          "-1": "semana passada"
        },
        "week-short": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "há {0} sem.",
            "other": "há {0} sem."
          },
          "-1": "semana passada"
        },
        "week-narrow": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "+{0} sem.",
            "other": "+{0} sem."
          },
          "past": {
            "one": "-{0} sem.",
            "other": "-{0} sem."
          },
          "-1": "semana passada"
        },
        "day": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-short": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-narrow": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "+{0} dia",
            "other": "+{0} dias"
          },
          "past": {
            "one": "há {0} dias",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "há {0} hora",
            "other": "há {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "há {0} h",
            "other": "há {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "+{0} h",
            "other": "+{0} h"
          },
          "past": {
            "one": "-{0} h",
            "other": "-{0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "há {0} minuto",
            "other": "há {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "há {0} min",
            "other": "há {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "+{0} min",
            "other": "+{0} min"
          },
          "past": {
            "one": "-{0} min",
            "other": "-{0} min"
          }
        },
        "second": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "há {0} segundo",
            "other": "há {0} segundos"
          }
        },
        "second-short": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "há {0} s",
            "other": "há {0} s"
          }
        },
        "second-narrow": {
          "0": "agora",
          "future": {
            "one": "+{0} s",
            "other": "+{0} s"
          },
          "past": {
            "one": "-{0} s",
            "other": "-{0} s"
          }
        }
      },
      "pt-MZ": {
        "nu": ["latn"],
        "year": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-short": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-narrow": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "+{0} ano",
            "other": "+{0} anos"
          },
          "past": {
            "one": "-{0} ano",
            "other": "-{0} anos"
          },
          "-1": "ano passado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "há {0} trimestre",
            "other": "há {0} trimestres"
          },
          "-1": "trimestre passado"
        },
        "quarter-short": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "há {0} trim.",
            "other": "há {0} trim."
          },
          "-1": "trim. passado"
        },
        "quarter-narrow": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "+{0} trim.",
            "other": "+{0} trim."
          },
          "past": {
            "one": "-{0} trim.",
            "other": "-{0} trim."
          },
          "-1": "trim. passado"
        },
        "month": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-short": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-narrow": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "+{0} mês",
            "other": "+{0} meses"
          },
          "past": {
            "one": "-{0} mês",
            "other": "-{0} meses"
          },
          "-1": "mês passado"
        },
        "week": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "há {0} semana",
            "other": "há {0} semanas"
          },
          "-1": "semana passada"
        },
        "week-short": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "há {0} sem.",
            "other": "há {0} sem."
          },
          "-1": "semana passada"
        },
        "week-narrow": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "+{0} sem.",
            "other": "+{0} sem."
          },
          "past": {
            "one": "-{0} sem.",
            "other": "-{0} sem."
          },
          "-1": "semana passada"
        },
        "day": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-short": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-narrow": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "+{0} dia",
            "other": "+{0} dias"
          },
          "past": {
            "one": "há {0} dias",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "há {0} hora",
            "other": "há {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "há {0} h",
            "other": "há {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "+{0} h",
            "other": "+{0} h"
          },
          "past": {
            "one": "-{0} h",
            "other": "-{0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "há {0} minuto",
            "other": "há {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "há {0} min",
            "other": "há {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "+{0} min",
            "other": "+{0} min"
          },
          "past": {
            "one": "-{0} min",
            "other": "-{0} min"
          }
        },
        "second": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "há {0} segundo",
            "other": "há {0} segundos"
          }
        },
        "second-short": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "há {0} s",
            "other": "há {0} s"
          }
        },
        "second-narrow": {
          "0": "agora",
          "future": {
            "one": "+{0} s",
            "other": "+{0} s"
          },
          "past": {
            "one": "-{0} s",
            "other": "-{0} s"
          }
        }
      },
      "pt-PT": {
        "nu": ["latn"],
        "year": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-short": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-narrow": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "+{0} ano",
            "other": "+{0} anos"
          },
          "past": {
            "one": "-{0} ano",
            "other": "-{0} anos"
          },
          "-1": "ano passado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "há {0} trimestre",
            "other": "há {0} trimestres"
          },
          "-1": "trimestre passado"
        },
        "quarter-short": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "há {0} trim.",
            "other": "há {0} trim."
          },
          "-1": "trim. passado"
        },
        "quarter-narrow": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "+{0} trim.",
            "other": "+{0} trim."
          },
          "past": {
            "one": "-{0} trim.",
            "other": "-{0} trim."
          },
          "-1": "trim. passado"
        },
        "month": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-short": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-narrow": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "+{0} mês",
            "other": "+{0} meses"
          },
          "past": {
            "one": "-{0} mês",
            "other": "-{0} meses"
          },
          "-1": "mês passado"
        },
        "week": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "há {0} semana",
            "other": "há {0} semanas"
          },
          "-1": "semana passada"
        },
        "week-short": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "há {0} sem.",
            "other": "há {0} sem."
          },
          "-1": "semana passada"
        },
        "week-narrow": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "+{0} sem.",
            "other": "+{0} sem."
          },
          "past": {
            "one": "-{0} sem.",
            "other": "-{0} sem."
          },
          "-1": "semana passada"
        },
        "day": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-short": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-narrow": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "+{0} dia",
            "other": "+{0} dias"
          },
          "past": {
            "one": "há {0} dias",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "há {0} hora",
            "other": "há {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "há {0} h",
            "other": "há {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "+{0} h",
            "other": "+{0} h"
          },
          "past": {
            "one": "-{0} h",
            "other": "-{0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "há {0} minuto",
            "other": "há {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "há {0} min",
            "other": "há {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "+{0} min",
            "other": "+{0} min"
          },
          "past": {
            "one": "-{0} min",
            "other": "-{0} min"
          }
        },
        "second": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "há {0} segundo",
            "other": "há {0} segundos"
          }
        },
        "second-short": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "há {0} s",
            "other": "há {0} s"
          }
        },
        "second-narrow": {
          "0": "agora",
          "future": {
            "one": "+{0} s",
            "other": "+{0} s"
          },
          "past": {
            "one": "-{0} s",
            "other": "-{0} s"
          }
        }
      },
      "pt-ST": {
        "nu": ["latn"],
        "year": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-short": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-narrow": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "+{0} ano",
            "other": "+{0} anos"
          },
          "past": {
            "one": "-{0} ano",
            "other": "-{0} anos"
          },
          "-1": "ano passado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "há {0} trimestre",
            "other": "há {0} trimestres"
          },
          "-1": "trimestre passado"
        },
        "quarter-short": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "há {0} trim.",
            "other": "há {0} trim."
          },
          "-1": "trim. passado"
        },
        "quarter-narrow": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "+{0} trim.",
            "other": "+{0} trim."
          },
          "past": {
            "one": "-{0} trim.",
            "other": "-{0} trim."
          },
          "-1": "trim. passado"
        },
        "month": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-short": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-narrow": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "+{0} mês",
            "other": "+{0} meses"
          },
          "past": {
            "one": "-{0} mês",
            "other": "-{0} meses"
          },
          "-1": "mês passado"
        },
        "week": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "há {0} semana",
            "other": "há {0} semanas"
          },
          "-1": "semana passada"
        },
        "week-short": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "há {0} sem.",
            "other": "há {0} sem."
          },
          "-1": "semana passada"
        },
        "week-narrow": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "+{0} sem.",
            "other": "+{0} sem."
          },
          "past": {
            "one": "-{0} sem.",
            "other": "-{0} sem."
          },
          "-1": "semana passada"
        },
        "day": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-short": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-narrow": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "+{0} dia",
            "other": "+{0} dias"
          },
          "past": {
            "one": "há {0} dias",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "há {0} hora",
            "other": "há {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "há {0} h",
            "other": "há {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "+{0} h",
            "other": "+{0} h"
          },
          "past": {
            "one": "-{0} h",
            "other": "-{0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "há {0} minuto",
            "other": "há {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "há {0} min",
            "other": "há {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "+{0} min",
            "other": "+{0} min"
          },
          "past": {
            "one": "-{0} min",
            "other": "-{0} min"
          }
        },
        "second": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "há {0} segundo",
            "other": "há {0} segundos"
          }
        },
        "second-short": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "há {0} s",
            "other": "há {0} s"
          }
        },
        "second-narrow": {
          "0": "agora",
          "future": {
            "one": "+{0} s",
            "other": "+{0} s"
          },
          "past": {
            "one": "-{0} s",
            "other": "-{0} s"
          }
        }
      },
      "pt-TL": {
        "nu": ["latn"],
        "year": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-short": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "dentro de {0} ano",
            "other": "dentro de {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-narrow": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "+{0} ano",
            "other": "+{0} anos"
          },
          "past": {
            "one": "-{0} ano",
            "other": "-{0} anos"
          },
          "-1": "ano passado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "próximo trimestre",
          "future": {
            "one": "dentro de {0} trimestre",
            "other": "dentro de {0} trimestres"
          },
          "past": {
            "one": "há {0} trimestre",
            "other": "há {0} trimestres"
          },
          "-1": "trimestre passado"
        },
        "quarter-short": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "dentro de {0} trim.",
            "other": "dentro de {0} trim."
          },
          "past": {
            "one": "há {0} trim.",
            "other": "há {0} trim."
          },
          "-1": "trim. passado"
        },
        "quarter-narrow": {
          "0": "este trim.",
          "1": "próximo trim.",
          "future": {
            "one": "+{0} trim.",
            "other": "+{0} trim."
          },
          "past": {
            "one": "-{0} trim.",
            "other": "-{0} trim."
          },
          "-1": "trim. passado"
        },
        "month": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-short": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "dentro de {0} mês",
            "other": "dentro de {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-narrow": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "+{0} mês",
            "other": "+{0} meses"
          },
          "past": {
            "one": "-{0} mês",
            "other": "-{0} meses"
          },
          "-1": "mês passado"
        },
        "week": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} semana",
            "other": "dentro de {0} semanas"
          },
          "past": {
            "one": "há {0} semana",
            "other": "há {0} semanas"
          },
          "-1": "semana passada"
        },
        "week-short": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "dentro de {0} sem.",
            "other": "dentro de {0} sem."
          },
          "past": {
            "one": "há {0} sem.",
            "other": "há {0} sem."
          },
          "-1": "semana passada"
        },
        "week-narrow": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "+{0} sem.",
            "other": "+{0} sem."
          },
          "past": {
            "one": "-{0} sem.",
            "other": "-{0} sem."
          },
          "-1": "semana passada"
        },
        "day": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-short": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "dentro de {0} dia",
            "other": "dentro de {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-narrow": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "+{0} dia",
            "other": "+{0} dias"
          },
          "past": {
            "one": "há {0} dias",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} hora",
            "other": "dentro de {0} horas"
          },
          "past": {
            "one": "há {0} hora",
            "other": "há {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "dentro de {0} h",
            "other": "dentro de {0} h"
          },
          "past": {
            "one": "há {0} h",
            "other": "há {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "+{0} h",
            "other": "+{0} h"
          },
          "past": {
            "one": "-{0} h",
            "other": "-{0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} minuto",
            "other": "dentro de {0} minutos"
          },
          "past": {
            "one": "há {0} minuto",
            "other": "há {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "dentro de {0} min",
            "other": "dentro de {0} min"
          },
          "past": {
            "one": "há {0} min",
            "other": "há {0} min"
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "+{0} min",
            "other": "+{0} min"
          },
          "past": {
            "one": "-{0} min",
            "other": "-{0} min"
          }
        },
        "second": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} segundo",
            "other": "dentro de {0} segundos"
          },
          "past": {
            "one": "há {0} segundo",
            "other": "há {0} segundos"
          }
        },
        "second-short": {
          "0": "agora",
          "future": {
            "one": "dentro de {0} s",
            "other": "dentro de {0} s"
          },
          "past": {
            "one": "há {0} s",
            "other": "há {0} s"
          }
        },
        "second-narrow": {
          "0": "agora",
          "future": {
            "one": "+{0} s",
            "other": "+{0} s"
          },
          "past": {
            "one": "-{0} s",
            "other": "-{0} s"
          }
        }
      },
      "pt": {
        "nu": ["latn"],
        "year": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "em {0} ano",
            "other": "em {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-short": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "em {0} ano",
            "other": "em {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "year-narrow": {
          "0": "este ano",
          "1": "próximo ano",
          "future": {
            "one": "em {0} ano",
            "other": "em {0} anos"
          },
          "past": {
            "one": "há {0} ano",
            "other": "há {0} anos"
          },
          "-1": "ano passado"
        },
        "quarter": {
          "0": "este trimestre",
          "1": "próximo trimestre",
          "future": {
            "one": "em {0} trimestre",
            "other": "em {0} trimestres"
          },
          "past": {
            "one": "há {0} trimestre",
            "other": "há {0} trimestres"
          },
          "-1": "último trimestre"
        },
        "quarter-short": {
          "0": "este trimestre",
          "1": "próximo trimestre",
          "future": {
            "one": "em {0} trim.",
            "other": "em {0} trim."
          },
          "past": {
            "one": "há {0} trim.",
            "other": "há {0} trim."
          },
          "-1": "último trimestre"
        },
        "quarter-narrow": {
          "0": "este trimestre",
          "1": "próximo trimestre",
          "future": {
            "one": "em {0} trim.",
            "other": "em {0} trim."
          },
          "past": {
            "one": "há {0} trim.",
            "other": "há {0} trim."
          },
          "-1": "último trimestre"
        },
        "month": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "em {0} mês",
            "other": "em {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-short": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "em {0} mês",
            "other": "em {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "month-narrow": {
          "0": "este mês",
          "1": "próximo mês",
          "future": {
            "one": "em {0} mês",
            "other": "em {0} meses"
          },
          "past": {
            "one": "há {0} mês",
            "other": "há {0} meses"
          },
          "-1": "mês passado"
        },
        "week": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "em {0} semana",
            "other": "em {0} semanas"
          },
          "past": {
            "one": "há {0} semana",
            "other": "há {0} semanas"
          },
          "-1": "semana passada"
        },
        "week-short": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "em {0} sem.",
            "other": "em {0} sem."
          },
          "past": {
            "one": "há {0} sem.",
            "other": "há {0} sem."
          },
          "-1": "semana passada"
        },
        "week-narrow": {
          "0": "esta semana",
          "1": "próxima semana",
          "future": {
            "one": "em {0} sem.",
            "other": "em {0} sem."
          },
          "past": {
            "one": "há {0} sem.",
            "other": "há {0} sem."
          },
          "-1": "semana passada"
        },
        "day": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "em {0} dia",
            "other": "em {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-short": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "em {0} dia",
            "other": "em {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "day-narrow": {
          "0": "hoje",
          "1": "amanhã",
          "2": "depois de amanhã",
          "future": {
            "one": "em {0} dia",
            "other": "em {0} dias"
          },
          "past": {
            "one": "há {0} dia",
            "other": "há {0} dias"
          },
          "-2": "anteontem",
          "-1": "ontem"
        },
        "hour": {
          "0": "esta hora",
          "future": {
            "one": "em {0} hora",
            "other": "em {0} horas"
          },
          "past": {
            "one": "há {0} hora",
            "other": "há {0} horas"
          }
        },
        "hour-short": {
          "0": "esta hora",
          "future": {
            "one": "em {0} h",
            "other": "em {0} h"
          },
          "past": {
            "one": "há {0} h",
            "other": "há {0} h"
          }
        },
        "hour-narrow": {
          "0": "esta hora",
          "future": {
            "one": "em {0} h",
            "other": "em {0} h"
          },
          "past": {
            "one": "há {0} h",
            "other": "há {0} h"
          }
        },
        "minute": {
          "0": "este minuto",
          "future": {
            "one": "em {0} minuto",
            "other": "em {0} minutos"
          },
          "past": {
            "one": "há {0} minuto",
            "other": "há {0} minutos"
          }
        },
        "minute-short": {
          "0": "este minuto",
          "future": {
            "one": "em {0} min.",
            "other": "em {0} min."
          },
          "past": {
            "one": "há {0} min.",
            "other": "há {0} min."
          }
        },
        "minute-narrow": {
          "0": "este minuto",
          "future": {
            "one": "em {0} min.",
            "other": "em {0} min."
          },
          "past": {
            "one": "há {0} min.",
            "other": "há {0} min."
          }
        },
        "second": {
          "0": "agora",
          "future": {
            "one": "em {0} segundo",
            "other": "em {0} segundos"
          },
          "past": {
            "one": "há {0} segundo",
            "other": "há {0} segundos"
          }
        },
        "second-short": {
          "0": "agora",
          "future": {
            "one": "em {0} seg.",
            "other": "em {0} seg."
          },
          "past": {
            "one": "há {0} seg.",
            "other": "há {0} seg."
          }
        },
        "second-narrow": {
          "0": "agora",
          "future": {
            "one": "em {0} seg.",
            "other": "em {0} seg."
          },
          "past": {
            "one": "há {0} seg.",
            "other": "há {0} seg."
          }
        }
      }
    },
    "availableLocales": ["pt-AO", "pt-CH", "pt-CV", "pt-GQ", "pt-GW", "pt-LU", "pt-MO", "pt-MZ", "pt-PT", "pt-ST", "pt-TL", "pt"]
  });
}